import React from "react";
import { ArrowRight, LayoutDashboard, Inbox, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import bannerImage from "/src/assets/analytics-banner.png"; // I'll need to move the generated image here

export const Home: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto space-y-8 animate-fade-in">
      <div className="space-y-8">
        <header>
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
            Federación Nacional de Cafeteros de Colombia
          </h1>
          <p className="text-gray-500 mt-1">Portal interno de dashboards y reportes</p>
        </header>

        {/* Banner Section */}
        <div className="relative rounded-3xl overflow-hidden aspect-[21/9] shadow-xl">
          <img
            src="/analytics_banner_cherry.png" 
            alt="Analytics Banner"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center p-8 md:p-12">
            <div className="max-w-md bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 text-white">
              <p className="text-lg font-medium mb-4">
                Acceda a dashboards interactivos y reportes para la toma de decisiones estratégicas. Este portal centraliza la información operativa y analítica de la organización.
              </p>
              <Button asChild className="bg-[#80142D] hover:bg-[#6b1126] text-white border-none gap-2">
                <Link to="/dashboard">
                  Ir al Dashboard <ArrowRight size={18} />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid md:grid-cols-2 gap-6">
          <Link to="/dashboard" className="group p-6 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all">
            <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center text-[#80142D] mb-4 group-hover:scale-110 transition-transform">
              <LayoutDashboard size={24} />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Dashboard</h3>
            <p className="text-sm text-gray-500">Visualice los indicadores clave en tiempo real</p>
          </Link>

          <Link to="/contacto" className="group p-6 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all cursor-pointer">
            <div className="w-12 h-12 rounded-xl bg-purple-50 flex items-center justify-center text-purple-600 mb-4 group-hover:scale-110 transition-transform">
              <PhoneCall size={24} />
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Contacto</h3>
            <p className="text-sm text-gray-500">Solicite información o soporte</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;
